/* eslint-disable */
// import libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

// import custom components
import EcgLoader from 'legacy/containers/EcgLoader';
import { DATASOURCES, getDataSource } from 'state/services/utils';
import CustomTableComponent from '../../components/Common/Table/CustomTableComponent';
import TableHeader from '../../components/Common/Table/TableHeader';
import FormattedDate from '../../components/Common/FormattedDate';

// filter components

// constants
import { CONDITION_COMPARE_TYPE } from '../../components/Common/Table/Constants/Constants';
import {
  AlertBoldTextCell,
  AlertHighlightCell,
} from '../../components/Common/Table/Utilities/CellStyle';
// constants
import { ACUITY_MAP } from '../../components/Common/Table/Constants/Constants';

// import actions
import {
  setInitialKardiaRxCCTEcgTableData,
  getKardiaRxCCTEcgTableData,
  routeChangeAction,
  updatedSelectedRxRecording,
} from '../../state/KardiaRxCCTPatient/KardiaRxCCTEcgTableActions';

import { printTechIntrString } from '../../pages/Annotation/utils/TechIntrParser'

import FullWidthECGPreview from '../../pages/Annotation/components/FullECGPreview';

// import css
import styles from './KardiaRxCCTEcgTable.css';
class KardiaRxCCTEcgTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // mdnRange: [0, 100],
    };
  }

  UNSAFE_componentWillMount() {
    const { match, location } = this.props;
    this.props.setInitialState(match, location);
    this.props.getKardiaRxCCTEcgTableData();
  }

  componentDidMount = () => {
    // this.removeDefaultSortClass();
  };

  componentWillReceiveProps = () => {
    // this.removeDefaultSortClass();
  };

  // remove default sort Icon class to fit custom icon
  removeDefaultSortClass = () => {
    if (document.querySelectorAll('.ant-table-column-sorter-full').length) {
      document
        .querySelectorAll('.ant-table-column-sorter-full')
        .forEach(e => e.remove());
    }
  };

  // Row clicked
  clickedRow = rowData => {
    const { updateRecordingState } = this.props;
    this.props.routeChangeAction(rowData.recordingId);
    this.props.updateRecordingState(rowData);
  };

  // filter change function
  filterChange = () => {
    // console.log('filterChange>>', newValue);
  };

  render() {
    const { KARDIA_RX_CCT_ECGS } = this.props;
    return (
      <React.Fragment>
        {KARDIA_RX_CCT_ECGS.recordings.isFetching ? (
          <EcgLoader />
        ) : (
          <CustomTableComponent
            columns={[
              {
                title: ({ sortOrder, sortColumn, filters }) => {
                  return (
                    <TableHeader
                      headerTxt="ACUITY"
                      keyMap="acuity"
                      enableFilterRow={false}
                      enableFilter={false}
                      filterFunction={() => this.filterChange()}
                      sortOrder={sortOrder}
                      sortColumn={sortColumn}
                    />
                  );
                },
                dataIndex: 'acuity',
                key: 'acuity',
                sorter: (a, b) => a.acuity && a.acuity.localeCompare(b.acuity),
                onCell: (record, rowIndex) => {
                  const highlight = AlertHighlightCell(
                    record.acuity,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    'mdn',
                  );
                  let rowStyle = {};
                  if (record.acuity === 'stable') {
                    rowStyle = { borderLeft: '4px solid #9DD3DE' };
                  } else if (record.acuity === 'mdn') {
                    rowStyle = { borderLeft: '4px solid #CC3D3F' };
                  }
                  return {
                    style: { ...rowStyle, ...highlight },
                  };
                },
                render: (text, record, index) => {
                  const boldText = AlertBoldTextCell(
                    record.isConfirmed,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    false,
                  );
                  const data = record.acuity && `${record.acuity}`;
                  return (
                    <p
                      style={{
                        fontWeight: boldText === true ? 'bold' : 'normal',
                      }}
                    >
                      {ACUITY_MAP[data]}
                    </p>
                  );
                },
              },
              {
                title: ({ sortOrder, sortColumn, filters }) => {
                  return (
                    <TableHeader
                      headerTxt="ECG ARRIVAL DATE/TIME"
                      keyMap="date"
                      enableFilterRow={false}
                      enableFilter={false}
                      filterFunction={() => this.filterChange()}
                      sortOrder={sortOrder}
                      sortColumn={sortColumn}
                    />
                  );
                },
                dataIndex: 'date',
                key: 'date',
                width: 100,
                sorter: (a, b) => {
                  const dateA = new Date(a.date);
                  const dateB = new Date(b.date);
                  return dateA - dateB;
                },
                onCell: (record, rowIndex) => {
                  const highlight = AlertHighlightCell(
                    record.acuity,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    'mdn',
                  );
                  return {
                    style: { ...highlight },
                  };
                },
                render: (text, record, index) => {
                  const boldText = AlertBoldTextCell(
                    record.isConfirmed,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    false,
                  );
                  return (
                    <p
                      style={{
                        fontWeight: boldText === true ? 'bold' : 'normal',
                      }}
                    >
                      <FormattedDate date={text} />
                    </p>
                  );
                },
              },
              {
                title: ({ sortOrder, sortColumn, filters }) => {
                  return (
                    <TableHeader
                      headerTxt="TECH INTERPRETATION"
                      keyMap="analysis"
                      enableFilterRow={false}
                      enableFilter={false}
                      filterFunction={() => this.filterChange()}
                      sortOrder={sortOrder}
                      sortColumn={sortColumn}
                    />
                  );
                },
                dataIndex: 'analysis',
                key: 'analysis',
                width: 220,
                sorter: (a, b) =>
                  a.analysis && a.analysis.localeCompare(b.analysis),
                onCell: (record, rowIndex) => {
                  const highlight = AlertHighlightCell(
                    record.acuity,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    'mdn',
                  );
                  return {
                    style: { ...highlight },
                  };
                },
                render: (text, record, index) => {
                  const boldText = AlertBoldTextCell(
                    record.isConfirmed,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    false,
                  );
                  let data = '';
                  if (record.analysis && record.analysis.length) {
                    data = printTechIntrString(record.analysis)
                  }
                  return (
                    <p
                      style={{
                        fontWeight: boldText === true ? 'bold' : 'normal',
                      }}
                    >
                      <u>{data && data.length >= 50 ? data.substring(0, 49) + '...' : data}</u>
                    </p>
                  );
                },
              },
              {
                title: ({ sortOrder, sortColumn, filters }) => {
                  return (
                    <TableHeader
                      headerTxt="SYMPTOMS"
                      keyMap="symptoms"
                      enableFilterRow={false}
                      enableFilter={false}
                      filterFunction={() => this.filterChange()}
                      sortOrder={sortOrder}
                      sortColumn={sortColumn}
                    />
                  );
                },
                dataIndex: 'symptoms',
                key: 'symptoms',
                width: 240,
                sorter: (a, b) =>
                  a.symptoms && a.symptoms.localeCompare(b.symptoms),
                onCell: (record, rowIndex) => {
                  const highlight = AlertHighlightCell(
                    record.acuity,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    'mdn',
                  );
                  return {
                    style: { ...highlight },
                  };
                },
                render: (text, record, index) => {
                  const boldText = AlertBoldTextCell(
                    record.isConfirmed,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    false,
                  );
                  const data = record.symptoms && `${record.symptoms}`;
                  return (
                    <p
                      style={{
                        fontWeight: boldText === true ? 'bold' : 'normal',
                      }}
                    >
                      {data && data.length >= 50 ? <u>{data.substring(0, 49) + '...'}</u> : <u>{data}</u>}
                    </p>
                  );
                },
              },
              {
                title: ({ sortOrder, sortColumn, filters }) => {
                  return (
                    <TableHeader
                      headerTxt="ACTIVITY"
                      keyMap="activities"
                      enableFilterRow={false}
                      enableFilter={false}
                      filterFunction={() => this.filterChange()}
                      sortOrder={sortOrder}
                      sortColumn={sortColumn}
                    />
                  );
                },
                dataIndex: 'activities',
                key: 'activities',
                sorter: (a, b) =>
                  a.activities && a.activities.localeCompare(b.activities),
                onCell: (record, rowIndex) => {
                  const highlight = AlertHighlightCell(
                    record.acuity,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    'mdn',
                  );
                  return {
                    style: { ...highlight },
                  };
                },
                render: (text, record, index) => {
                  const boldText = AlertBoldTextCell(
                    record.isConfirmed,
                    CONDITION_COMPARE_TYPE.EQUAL,
                    false,
                  );
                  const data = record.activities && `${record.activities}`;
                  return (
                    <p
                      style={{
                        fontWeight: boldText === true ? 'bold' : 'normal',
                      }}
                    >
                      {data}
                    </p>
                  );
                },
              },
              {
                title: ({ sortOrder, sortColumn, filters }) => {
                  return (
                    <TableHeader
                      headerTxt="HIGHLIGHT"
                      keyMap="highlight"
                      enableFilterRow={false}
                      enableFilter={false}
                      filterFunction={() => this.filterChange()}
                      sortOrder={sortOrder}
                      sortColumn={sortColumn}
                    />
                  );
                },
                dataIndex: 'highlight',
                key: 'highlight',
                width: 360,
                onCell: () => {
                  return {
                    style: {    
                      position: 'relative',
                      padding: 0,
                      overflow:'hidden',
                      width: "360px",
                      height: "77px",
                      borderBottom: "0.1px solid #1F356866"
                    },
                  }
                },
                render: (text, record, index) => {
                  if(record.highlightPreview || record.previewData){
                    return (
                      <React.Fragment> 
                        {record.highlightPreview ? (
                          <FullWidthECGPreview 
                          classApplied
                          sample = {JSON.parse(record.highlightPreview).intervals[0].samples}
                          ecgTitle = {JSON.parse(record.highlightPreview).intervals[0].lead}
                          beats = {JSON.parse(record.highlightPreview).beats}
                          height = {150}
                          />
                        ) :(
                          <FullWidthECGPreview
                            classApplied
                            sample = {record.previewData.samples.leadI}
                            height = {150}
                          />
                        )}
                      </React.Fragment>
                    )
                  } else {
                    return (
                      <p style={{textAlign: 'center'}}>Preview Unavailable</p>
                    )
                  }
                }
              },
            ]}
            data={KARDIA_RX_CCT_ECGS.recordings.data[0]}
            clickedRow={this.clickedRow}
            scrollHeight={{ y:  'calc(100vh - 35em)'}}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const KARDIA_RX_CCT_ECGS = state.kardiaRx.kardiaRxCCTEcg;

  return {
    me,
    KARDIA_RX_CCT_ECGS,
  };
};

const mapActionCreators = {
  setInitialState: setInitialKardiaRxCCTEcgTableData,
  getKardiaRxCCTEcgTableData,
  routeChangeAction,
  updateRecordingState: updatedSelectedRxRecording,
};

export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(KardiaRxCCTEcgTable));



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxCCTEcgTable/KardiaRxCCTEcgTable.jsx